<div *ngIf="(rsvImageModels?.length > 0 || imageCollection?.length > 0) && !isHandset else mobileTemplate" id="imageCarouselContainer" [ngClass]="{'open': open, 'setNameGridViewEnabled': setName, 'setNameGridViewDisabled': !setName, 'allClose': allClose}">

    <div *ngIf="isHistoryTabEnabled" class="history" [ngClass]="{'activeTab' : history, 'inactiveTab' : !history}">
        <h5 ><i [hidden]="history"  class="fa fa-lg fa-caret-up" (click)="toggleTabs('1')" ></i><i [hidden]="!history" class="fa fa-lg fa-caret-down" (click)="toggleTabs(1)"></i>
            <div class="header"  (click)="toggleTabs('1')">
            <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the recently viewed bar">
                Recently Viewed
            </label>
            </div>
        </h5>
    </div>

    <div *ngIf="isRelatedTabEnabled" class="relatedImageSet" [ngClass]="{'activeTab' : related, 'inactiveTab' : !related}">
        <h5 ><i [hidden]="related"  class="fa fa-lg fa-caret-up" (click)="toggleTabs('2')" ></i><i [hidden]="!related" class="fa fa-lg fa-caret-down" (click)="toggleTabs('2')"></i>
            <div class="header"  (click)="toggleTabs('2')">
            <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the related image set bar">
               Related Image Sets ({{rsvImageModels.length}})
            </label>
            </div>
        </h5>
    </div>

    <div *ngIf="isSetNameTabEnabled" class="setName " [ngClass]="{'activeTab' : setName, 'inactiveTab' : !setName}">
        <h5 ><i [hidden]="setName"  class="fa fa-lg fa-caret-up" (click)="toggleTabs('3')" ></i><i [hidden]="!setName" class="fa fa-lg fa-caret-down" (click)="toggleTabs('3')"></i>
            <div class="header"  (click)="toggleTabs('3')">
            <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the set name bar">
                ({{selectedSetName}})
            </label>
            </div>
        </h5>
    </div>

    <div class="imageCarouselDiv" *ngIf="history && historyToDisplay && historyToDisplay?.length > 0">

        <app-image-carousel #imageCarousel
            [isRSVMode]='false'
            [recentlyViewedImages]="historyToDisplay"
            [recentlyViewedImagesMode]="true"
            (recordSelected)="handleSelectImageCarouselThumbnail($event)">
        </app-image-carousel>

    </div>

    <div class="imageCarouselDiv" *ngIf="related">

        <app-image-carousel #imageCarousel *ngIf="rsvImageModels && rsvImageModels?.length > 0"
            [rsvImageModels]="rsvImageModels"
            [isRSVMode]='true'
            [recentlyViewedImagesMode]="false"
            (recordSelected)="handleSelectImageCarouselThumbnail($event)">
        </app-image-carousel>

    </div>
    
    <div class="imageCarouselDiv" *ngIf="setName && relevantSetImages?.length > 0">
        
        <div class="goToGalleryButton" (click)="changeFilterToMe($event)">
            VIEW IN GALLERY ->
        </div>
        <div class="setNameDiv">
            <app-thumbnail  class="thumb" *ngFor="let t of relevantSetImages" [showStacked]="false" [animate]="true" [showSourceInfo]="false" [batchEditMode]="false" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail($event)" [imageData]="t" [expandMode]="0"></app-thumbnail>
        </div>
    </div>

</div>

<ng-template #confirmFilterModal>
    <h5>You have filters applied already.</h5>
    <label>
        Would you like to filter by related image set
        <div class="badge badge-pill badge-dark mb-1">
            {{ selectedRelatedImageSetName }}
        </div>
        instead?
    </label>
    <p>You will be returned to the {{ gallerySvc.writeGalleryPageText() }} gallery.</p>
</ng-template>



<ng-template #mobileTemplate>
    
    <div *ngIf="(rsvImageModels?.length > 0 || imageCollection?.length > 0)" id="imageCarouselContainerMobile" [ngClass]="{'openMobile': open, 'setNameGridViewEnabledMobile': setName, 'setNameGridViewDisabledMobile': !setName, 'allClose': allClose}">

        <div class="tabsSection mobile">
            <div *ngIf="isHistoryTabEnabled" class="tab history mobile" [ngClass]="{'activeTabMobile' : history, 'inactiveTab' : !history}">
                <h5>
                    <i [hidden]="history" class="fa fa-lg fa-caret-up" (click)="toggleTabs('1')"></i>
                    <i [hidden]="!history" class="fa fa-lg fa-caret-down" (click)="toggleTabs('1')"></i>
                    <div class="header" (click)="toggleTabs('1')">
                        <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the recently viewed bar">
                            Recently Viewed
                        </label>
                    </div>
                </h5>
            </div>
        
            <div *ngIf="isRelatedTabEnabled" class="tab relatedImageSet mobile" [ngClass]="{'activeTabMobile' : related, 'inactiveTab' : !related}">
                <h5>
                    <i [hidden]="related" class="fa fa-lg fa-caret-up" (click)="toggleTabs('2')"></i>
                    <i [hidden]="!related" class="fa fa-lg fa-caret-down" (click)="toggleTabs('2')"></i>
                    <div class="header" (click)="toggleTabs('2')">
                        <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the related image set bar">
                            Related Image Sets ({{rsvImageModels.length}})
                        </label>
                    </div>
                </h5>
            </div>
        
            <div *ngIf="isSetNameTabEnabled" class="tab setName mobile" [ngClass]="{'activeTabMobile' : setName, 'inactiveTab' : !setName}">
                <h5>
                    <i [hidden]="setName" class="fa fa-lg fa-caret-up" (click)="toggleTabs('3')"></i>
                    <i [hidden]="!setName" class="fa fa-lg fa-caret-down" (click)="toggleTabs('3')"></i>
                    <div class="header" (click)="toggleTabs('3')">
                        <label class="col-form-label me-1" for="imageSetsDropdown" matTooltip="Toggle the set name bar">
                            ({{selectedSetName}})
                        </label>
                    </div>
                </h5>
            </div>
        </div>

        <div class="imageCarouselDivMobile buttonsContainerMobile">
            <app-slant-button *ngIf="setName && relevantSetImages?.length > 0"
                btnColor="green" 
                [btnIconClass]="'fas fa-arrow-alt-right'"
                (click)="changeFilterToMe($event)">
                View in Gallery
            </app-slant-button>

            <app-slant-button
            btnColor="red" 
            [btnIconClass]="'fad fa-times'"
            (click)="toggleTabs('0')">
            Close
            </app-slant-button>
        </div>
        
        <div class="imageCarouselDivMobile" *ngIf="history && historyToDisplay && historyToDisplay?.length > 0">

            <div class="thumbnailsHolderSectionMobile boundSetMode" *ngIf="historyToDisplay && historyToDisplay.length > 0">
                <app-thumbnail [class.outlined]="t.name === displayName" class="thumb" *ngFor="let t of historyToDisplay" [animate]="false" [showStacked]="false" [batchEditMode]="false" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail(t)" [imageData]="t" [expandMode]="libViewModes.condensedMode"></app-thumbnail>
            </div>
         
        </div>
    
        <div class="imageCarouselDivMobile" *ngIf="related">
    
            <div class="thumbnailsHolderSectionMobile" *ngIf="rsvImageModels && rsvImageModels.length > 0">
                <app-thumbnail [class.outlined]="t.name === displayName" class="thumb" *ngFor="let t of rsvImageModels" [animate]="true" [showStacked]="true" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail($event)" [isRelatedImageSetViewMode]='true' [relatedImageSetViewData]="t"></app-thumbnail>
            </div>
    
        </div>
        
        <div class="imageCarouselDivMobile" *ngIf="setName && relevantSetImages?.length > 0">
            
            <div class="goToGalleryButtonMobile setNameDivMobile">
                <!-- VIEW IN GALLERY -> -->
                <app-thumbnail  class="thumb" *ngFor="let t of relevantSetImages" [showStacked]="false" [animate]="true" [showSourceInfo]="false" [batchEditMode]="false" (recordSelectedEmitter)="handleSelectImageCarouselThumbnail($event)" [imageData]="t" [expandMode]="0"></app-thumbnail>
            </div>
        </div>

    </div>
</ng-template>